export default __webpack_public_path__ + "static/media/site_plans.1948bdf6.svg";